import { Link } from "react-router-dom";
import { Phone, MapPin, Clock, Sun } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL, ADDRESS, HOURS, SERVED_AREAS } from "@/constants/site";

const Footer = () => (
  <footer className="bg-slate-950 text-slate-300">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div className="lg:col-span-1">
          <div className="inline-block rounded-2xl bg-white px-4 py-3">
            <img src="/logo-full.png" alt="Swarajya Solar Services" className="h-14 w-auto object-contain" />
          </div>
          <p className="mt-5 text-sm leading-relaxed text-slate-400">
            Rooftop solar installation, subsidy support and maintenance for homes,
            businesses and industries across {SERVED_AREAS}.
          </p>
          <p className="mt-4 inline-flex items-center gap-2 rounded-full bg-slate-900 px-3 py-1.5 text-xs font-semibold text-amber-400">
            <Sun className="h-3.5 w-3.5" /> Powering the region since 2017
          </p>
        </div>
        <div>
          <h3 className="font-display text-sm font-bold uppercase tracking-[0.2em] text-white">
            Quick Links
          </h3>
          <ul className="mt-5 space-y-3 text-sm">
            <li><Link to="/" data-testid="footer-home-link" className="hover:text-orange-400 transition-colors">Home</Link></li>
            <li><Link to="/services" data-testid="footer-services-link" className="hover:text-orange-400 transition-colors">Services</Link></li>
            <li><Link to="/contact" data-testid="footer-contact-link" className="hover:text-orange-400 transition-colors">Contact & Free Quote</Link></li>
            <li><Link to="/privacy-policy" data-testid="footer-privacy-link" className="hover:text-orange-400 transition-colors">Privacy Policy</Link></li>
            <li><Link to="/terms-and-conditions" data-testid="footer-terms-link" className="hover:text-orange-400 transition-colors">Terms & Conditions</Link></li>
          </ul>
        </div>
        <div>
          <h3 className="font-display text-sm font-bold uppercase tracking-[0.2em] text-white">
            Services
          </h3>
          <ul className="mt-5 space-y-3 text-sm text-slate-400">
            <li>On-Grid Rooftop Solar</li>
            <li>Commercial & Industrial Solar</li>
            <li>Off-Grid & Hybrid Systems</li>
            <li>Solar Street Lights & Control Panels</li>
            <li>Maintenance & Health Audits</li>
          </ul>
        </div>
        <div>
          <h3 className="font-display text-sm font-bold uppercase tracking-[0.2em] text-white">
            Contact
          </h3>
          <ul className="mt-5 space-y-4 text-sm">
            <li>
              <a href={PHONE_TEL} data-testid="footer-call-link" className="flex items-start gap-3 hover:text-orange-400 transition-colors">
                <Phone className="h-4 w-4 mt-0.5 text-orange-500 shrink-0" />
                {PHONE_DISPLAY}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin className="h-4 w-4 mt-0.5 text-orange-500 shrink-0" />
              {ADDRESS}
            </li>
            <li className="flex items-start gap-3">
              <Clock className="h-4 w-4 mt-0.5 text-orange-500 shrink-0" />
              {HOURS}
            </li>
          </ul>
        </div>
      </div>
      <div className="mt-14 flex flex-col sm:flex-row items-center justify-between gap-4 border-t border-slate-800 pt-8 text-xs text-slate-500">
        <p data-testid="footer-copyright">© {new Date().getFullYear()} Swarajya Solar Services. All rights reserved.</p>
        <div className="flex items-center gap-6">
          <Link to="/privacy-policy" data-testid="footer-bottom-privacy-link" className="hover:text-orange-400 transition-colors">Privacy Policy</Link>
          <Link to="/terms-and-conditions" data-testid="footer-bottom-terms-link" className="hover:text-orange-400 transition-colors">Terms & Conditions</Link>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
